module.exports = __webpack_public_path__ + "img/wx-qr.ce0f744c.jpg";